import React from "react";

const Input = (props) => {
  const {
    label,
    placeholder,
    type,
    id,
    name,
    value,
    onChange,
    index,
    className,
    classNameInput,
    disabled = false,
  } = props;

  return (
    <div className={className}>
      <div className="search_bar">
        <div className="form-label">{label}</div>
        <input
          className={`${classNameInput} search-input placeholder:text-gray-200`}
          placeholder={placeholder}
          name={name}
          type={type}
          id={id}
          disabled={disabled}
          // disabled={name === 'url' || name === "user_email" || name === "calendar" || name === 'guest' ? true : false}
          value={value}
          onChange={onChange}
          onWheel={(e) => e.target.blur()}
        />
      </div>
    </div>
  );
};

export default Input;
